<template>
<transition name="modal">
  <div class="modal-wrapper">
    <div class="modal-container errordetails-modal">
      <button type="button" class="close" aria-label="Close"><span aria-hidden="true" @click="$emit('errorDetailsModalClose')">&times;</span></button>
      <div class="row">
        <h2>{{$options.filters.translate('Errors', lang)}}: {{ errorsDetailsModalData[0].area }} / {{ errorsDetailsModalData[0].object }}</h2>
        <h4>{{$options.filters.translate('Select restaurants', lang)}}: </h4>
        <form class="form-inline">
          <div class="checkbox" v-for="restaurant in restaurants" :key="restaurant.id">
            <label>
              <input type="checkbox" :id="restaurant.restaurant" :value="restaurant.restaurant" v-model="checkedRestaurants"> {{restaurant.restaurant}} / {{restaurant.counter}}
            </label>
          </div>
        </form>
        <h4>{{$options.filters.translate('Select kiosks', lang)}}: </h4>
        <form class="form-inline">
          <div class="checkbox" v-for="kiosk in kiosks" :key="kiosk.kiosk">
            <label>
              <input type="checkbox" :id="kiosk.kiosk" :value="kiosk.kiosk" v-model="checkedKiosks"> {{kiosk.kiosk}} / {{kiosk.counter}}
            </label>
          </div>
        </form>
        <h4>{{$options.filters.translate('Select errors', lang)}}: </h4>
        <form class="form-inline">
          <div class="checkbox" v-for="errorType in errorTypes" :key="errorType.errorType">
            <label>
              <input type="checkbox" :id="errorType.errorType" :value="errorType.errorType" v-model="checkederrorTypes"> {{errorType.errorType}} / {{errorType.counter}}
            </label>
          </div>
        </form>
        <div class="col-xs-12">
          <!-- <p><pre>{{ errors }}</pre></p> -->
          <table class="table table-condensed table-hover errordetails">
            <thead>
              <tr>
                <th>{{$options.filters.translate('Amount', lang)}}</th>
                <th>{{$options.filters.translate('Code', lang)}}</th>
                <th>{{$options.filters.translate('Place', lang)}}</th>
                <th>{{$options.filters.translate('Object', lang)}}</th>
                <th>{{$options.filters.translate('Error', lang)}}</th>
                <th>{{$options.filters.translate('Restaurant', lang)}} </th>
                <th>{{$options.filters.translate('Kiosk', lang)}} </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(error, key) in errors" :key="key">
                <td>{{error.failures}}</td>
                <td>{{error.code}}</td>
                <td>{{error.area}}</td>
                <td>{{error.object}}</td>
                <td>{{error.error}}</td>
                <td>{{error.restaurant}}</td>
                <td>{{error.deviceName}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</transition>

</template>
<script>

export default {
  props: ['errorsDetailsModalData', 'lang'],
  data () {
    return {
      checkedRestaurants: [],
      checkedKiosks: [],
      checkederrorTypes: []
    }
  },
  components: {
  },
  watch: {
  },
  methods: {
    escapeModal (e) {
      if (e.key === 'Escape') {
        this.$emit('errorDetailsModalClose')
      }
    }
  },
  created () {
    window.addEventListener('keyup', this.escapeModal, false)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.escapeModal, false)
  },
  computed: {
    errors () {
      if (this.checkedRestaurants.length === 0 && this.checkedKiosks.length === 0 && this.checkederrorTypes.length === 0) {
        return this.errorsDetailsModalData
      }
      // apply restaurant filter
      let resultFilteredRestaurants = []
      if (this.checkedRestaurants.length > 0) {
        for (let index = 0; index < this.errorsDetailsModalData.length; index++) {
          if (this.checkedRestaurants.indexOf(this.errorsDetailsModalData[index].restaurant) > -1) {
            resultFilteredRestaurants.push(this.errorsDetailsModalData[index])
          }
        }
      } else {
        resultFilteredRestaurants = this.errorsDetailsModalData
      }
      // apply kiosk filter
      let resultFilteredKiosks = []
      if (this.checkedKiosks.length > 0) {
        for (let index = 0; index < resultFilteredRestaurants.length; index++) {
          if (this.checkedKiosks.indexOf(resultFilteredRestaurants[index].deviceName) > -1) {
            resultFilteredKiosks.push(resultFilteredRestaurants[index])
          }
        }
      } else {
        resultFilteredKiosks = resultFilteredRestaurants
      }
      // apply types filter
      let resultFilteredErrors = []
      if (this.checkederrorTypes.length > 0) {
        for (let index = 0; index < resultFilteredKiosks.length; index++) {
          if (this.checkederrorTypes.indexOf(resultFilteredKiosks[index].error) > -1) {
            resultFilteredErrors.push(resultFilteredKiosks[index])
          }
        }
      } else {
        resultFilteredErrors = resultFilteredRestaurants
      }
      return resultFilteredErrors
    },
    restaurants () {
      let restaurants = []
      for (let index = 0; index < this.errorsDetailsModalData.length; index++) {
        const element = this.errorsDetailsModalData[index]
        if (restaurants.findIndex(rest => rest.restaurant === element.restaurant) === -1) {
          restaurants.push({restaurant: element.restaurant, counter: element.failures})
        } else {
          restaurants[restaurants.findIndex(rest => rest.restaurant === element.restaurant)].counter += element.failures
        }
      }
      return restaurants.sort()
    },
    kiosks () {
      let kiosks = []
      for (let index = 0; index < this.errors.length; index++) {
        const element = this.errors[index]
        if (kiosks.findIndex(kiosk => kiosk.kiosk === element.deviceName) === -1) {
          kiosks.push({kiosk: element.deviceName, counter: element.failures})
        } else {
          kiosks[kiosks.findIndex(kiosk => kiosk.kiosk === element.deviceName)].counter += element.failures
        }
      }
      return kiosks.sort()
    },
    errorTypes () {
      let errorTypes = []
      for (let index = 0; index < this.errors.length; index++) {
        const element = this.errors[index]
        if (errorTypes.findIndex(errorType => errorType.errorType === element.error) === -1) {
          errorTypes.push({errorType: element.error, counter: element.failures})
        } else {
          errorTypes[errorTypes.findIndex(errorType => errorType.errorType === element.error)].counter += element.failures
        }
      }
      return errorTypes.sort()
    }
  }
}
</script>
<style lang="sass" scoped>
@import "~sass/_variables.scss"
h4
  border-bottom: solid 1px white
.checkbox
  margin-right: 12px
.errordetails-modal
  position: fixed
  z-index: 999
  margin-top: -20px !important
  margin-left: -20px !important
  overflow: scroll
</style>



// WEBPACK FOOTER //
// src/components/reports/ErrorDetailsModal.vue